import { Type } from "@themes/pollinator/ui/Type";

export type Props = {
  // When undefined or empty, the component renders nothing — safe to mount
  // unconditionally. The parent passes the output of `detectKnownBadBrowser`
  // directly, so silence-on-not-matching is the desired contract.
  title?: string;
  body?: string;
};

// Visual treatment mirrors the existing iOS Chrome disclaimer in
// VideoMeetingJoin.tsx (Type h4 in text-error-700 + bordered card with caption)
// so users encountering both warnings see consistent UI. Assistive-tech
// semantics are intentionally stronger here — the wrapper is `role="alert"` so
// screen readers announce the warning when it mounts, vs. the iOS Chrome
// disclaimer which is silent until the user navigates into it. The 30-second-
// timeout consequence justifies the assertive announcement.
export function KnownBadBrowserWarning({ title, body }: Props) {
  if (!title) return null;
  return (
    <div className="flex flex-col gap-2" role="alert">
      <Type as="h2" variant="h4" className="text-error-700">
        {title}
      </Type>
      <div className="p-4 border border-error-700 rounded-md flex flex-col gap-2">
        <Type variant="caption" className="text-error-700">
          {body}
        </Type>
      </div>
    </div>
  );
}
